/*
 * @Author: Tina Huang
 * @Date: 2024-01-25 18:31:49
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 16:14:04
 * @Description:
 */

import dayjs from 'dayjs'
import { VIP_MEMBER, VipMembers } from '@/constants/vips'

export const saveVIP = (info: VIP_MEMBER, onSuccess: () => void, onError: () => void) => {
  const { order, phone, nickname } = info
  let _nickname = nickname
  const _member = VipMembers.find((item) => item.order === order && item.phone === phone)
  if (_member) {
    if (!nickname) _nickname = hidePhone(phone)
    localStorage.member = window.btoa(encodeURIComponent(JSON.stringify({ ...info, nickname: _nickname })))
    onSuccess?.()
  } else {
    onError?.()
  }
}

export const checkVIP = (): VIP_MEMBER | null => {
  const token = localStorage.member
  if (!token) return null
  if (window?.atob(token)) {
    const _token = window?.atob(token)
    const __token = decodeURIComponent(_token)
    return JSON.parse(__token)
  }
  return null
}

export const hidePhone = (phone: string) => phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3')

export const formatDate = (d: string | number | Date | dayjs.Dayjs | null | undefined, f: string | undefined = 'YYYY/MM/DD') =>
  dayjs(d).format(f)

export const is_weixn = () => {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i)?.[0] === 'micromessenger') {
    return true
  } else {
    return false
  }
}
